import {useState} from 'react';
import {ReadCampaign} from '@tinct/core-api-models';
import {usePatchCampaign} from '@tinct/core-api';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from '@tinct/web-components';
import {toast} from 'sonner';

type RenameCampaignModalProps = {
  campaign: ReadCampaign;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRenamed?: () => void;
};

export const RenameCampaignModal = ({
  campaign,
  open,
  onOpenChange,
  onRenamed,
}: RenameCampaignModalProps) => {
  const [name, setName] = useState(campaign.name ?? '');
  const [prevOpen, setPrevOpen] = useState(open);

  // Reset the field to the campaign's current name each time the modal opens
  if (open !== prevOpen) {
    setPrevOpen(open);
    if (open) setName(campaign.name ?? '');
  }

  const {mutate: patchCampaign, isPending} = usePatchCampaign({
    onSuccess: () => {
      toast.success(`${name} successfully renamed.`);
      onOpenChange(false);
      onRenamed?.();
    },
  });

  const handleSave = () => {
    if (!campaign.id || !name.trim()) return;
    patchCampaign({id: campaign.id, data: {name: name.trim()}});
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Rename campaign</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <Label htmlFor="campaign-name">Name</Label>
          <Input
            id="campaign-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSave();
            }}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={isPending || !name.trim()}>
            Save changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};